<h2 mat-dialog-title>Uploading Images</h2>
<mat-dialog-content class="mat-typography">
  <p>Imagery if done right is the most captivating part of your event listing, here are some tips on how best optimise
    your images for your listing.</p>
  <h3>Shape and Dimensions</h3>
  <p>Your images are going to feature on many websites, apps and devices of all shapes and sizes, for best and
    consistent results we recommend that the orientation of your image is landscape and has an aspect ratio of 3 x 2.
  </p>
  <div class="examples">
      <div class="bad example">
        <span class="icon">
          <fa name="times"></fa>
        </span>
        <img class="bad-image-example" src="assets/images/bad-images.png" />

      </div>
      <div class="good example">
        <span class="icon">
          <fa name="check"></fa>
        </span>
        <img class="good-image-example" src="assets/images/good-images.png" />
      </div>
    </div>
  <h3>Big but not too Big</h3>
  <p>We want to feature the highest quality image possible for your event, however if the image file size is too big it
    will render very slowly on your listing and in some instances may not load at all. So we recommend that you upload
    an image no more than 2048KiB (2MB) in size. A rule of thumb would be to ensure that your images are 900 pixels wide 600
    pixels high.</p>
  <p>If your images is less than 100KB then these images will appear pixelated on your listing.</p>
  <h3>Image file type</h3>
  <p>Images can be stored in all sorts of formats, however not all devices can display all formats. For this reason all
    images uploaded must be in .jpg, .jpeg, .gif, .png or .webp format.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="footer">
    <button mat-button mat-dialog-close type="button">Got it!</button>
  </div>
</mat-dialog-actions>